module.exports = __webpack_public_path__ + "static/media/default.d33db32f.png";